export const GROUP_INFO = {
  name: "D & D Lanka Group of Companies",
  tagline: "Connecting Heritage with Modern Living",
  description: "D & D Lanka Group of Companies is a premier conglomerate specializing in the export of authentic spices and the manufacturing of high-end apparel. We bridge the gap between traditional craftsmanship and global markets."
};

export const COMPANIES = [
  {
    id: 'spices',
    slug: 'spices',
    name: 'Spice Grains Agro (PVT) Ltd',
    description: ' wholesale supplier of essential commodities including sugar, wheat flour, pulses, daily staples, and spices. We deliver premium value through uncompromised quality and reliable supply, offering competitive pricing and trusted partnerships that keep your business running efficiently with consistent quality and sustained supply',
    colorScheme: 'green',
    icon: 'leaf',
    heroIcon: 'utensils-crossed',
    services: [
      { title: 'Imports', desc: 'Supplying all sort of Premium Spices, Pulses, Grains and all Agro Products' },
      { title: 'Wholesale Supply', desc: 'B2B supply chain solutions for global food manufacturers.' },
      { title: 'Natural Oils', desc: 'Cold-pressed essential oils and herbal extracts.' },
     
    ]
  },
  {
    id: 'apparel',
    slug: 'apparel',
    name: 'Ceylonese Apparel House',
    description: 'Your Global Partner in Comprehensive Apparel Sourcing From the high-performance demands of sportswear to the intricate craftsmanship of traditional party wear, Ceylonese Apparel House is a premier importer and supplier of high-quality textiles. We bridge the gap between global manufacturing excellence and your specific retail or corporate needs.',
    colorScheme: 'red',
    icon: 'shirt',
    heroIcon: 'shopping-bag',
    services: [
      { title: 'Custom Manufacturing', desc: 'End-to-end production for global fashion labels.' },
      { title: 'Sustainable Fabric', desc: 'Utilizing recycled materials and organic cotton.' },
      { title: 'Global Logistics', desc: 'Direct-to-warehouse shipping and inventory management.' }
    ]
  },
   {
    id: 'commodities',
    slug: 'commodities',
    name: 'Spice Grain Commodities',
    description: 'Connecting Global Markets with Sri Lankan Quality for Pepper, Cinnamon, Tea, Coconut, Coconut Products, Rice, Fruits, Vegetables & Authentic Sri Lankan Spices from the farms to your doorsteps. ',
    colorScheme: 'red',
    icon: 'global',
    heroIcon: 'shopping-bag',
    services: [
      { title: 'Custom Manufacturing', desc: 'End-to-end production for global fashion labels.' },
      { title: 'Sustainable Fabric', desc: 'Utilizing recycled materials and organic cotton.' },
      { title: 'Global Logistics', desc: 'Direct-to-warehouse shipping and inventory management.' }
    ]
  }
];
